import React, {useEffect} from 'react';
import {Outlet} from 'react-router-dom';
import {LoaderSplash} from '../../components/atoms/LoaderSplash';
import {useOkta} from '../../hooks';
import {useNavigation} from '../useNavigation';

const Guest = () => {
  const {authState} = useOkta();

  const {goToMain} = useNavigation();

  useEffect(() => {
    if (!authState) {
      return;
    }

    if (authState.isAuthenticated) {
      goToMain({replace: true});
    }
  }, [authState, goToMain]);

  if (!authState || authState.isAuthenticated) {
    return <LoaderSplash />;
  }

  return <Outlet />;
};

export default React.memo(Guest);
